module.exports = __webpack_public_path__ + "static/media/hugo.a9657ebc.png";